import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * News section component.
 * Renders the news section with icon, customizable label, and news content.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters containing news label
 * @returns {JSX.Element}
 */
export default function NewsSection({ parameters }) {
  const { t } = useLanguage()

  return (
    <div className="welcomeLineDiv welcomeNews">
      <span id="mainPopupNewsFile" data-testid="mainPopupNewsFile" className="btn shortwaysIcon newsIcon" />
      <span id="newsLabel" className="welcomeTitle">
        {parameters.newsLabel || t("Text.textNewsInput")}
      </span>
      <div className="categoryTitle">
        <div className="welcomeLineDiv">
          <div className="shortwaysNewsList">
            <div className="shortwaysCategory">
              <span className="itemName">{t("AssistantWindow.assistantWindowNews")}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
